import './instance';

// register create function for bundleid
Oskari.bundle('telemetry', () => Oskari.clazz.create('Oskari.mapframework.bundle.telemetry.TelemetryBundleInstance'));